import {
  ContentRequest,
  ContentRequestState,
  ContentRequestType,
} from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import CreateContentActionButtons from './CreateContentActionButtons';
import UpdateContentActionButtons from './UpdateContentActionButtons';

interface Props {
  contentRequest: ContentRequest;
  updateContentRequest: (
    contentRequestId: string,
    state: ContentRequestState,
    assigneeId: string,
  ) => void;
}

const ContentRequestActionButtons = ({ contentRequest, updateContentRequest }: Props) => {
  const { requestType } = contentRequest;
  return requestType === ContentRequestType.Update ? (
    <UpdateContentActionButtons
      updateContentRequest={updateContentRequest}
      contentRequest={contentRequest}
    />
  ) : (
    <CreateContentActionButtons
      updateContentRequest={updateContentRequest}
      contentRequest={contentRequest}
    />
  );
};

export default ContentRequestActionButtons;
